import {
  PodcastPromoCreditsResponse,
  UserSubscription,
} from '@sparemin/api-sdk';
import { millicentsToDollars } from 'utils/money';

export const planNameSelector = (d: UserSubscription) => d.subscribedPlan.name;

export const remainingMilliCentSelector = (d: PodcastPromoCreditsResponse) =>
  d.remainingMilliCent;

export const totalMilliCentSelector = (d: PodcastPromoCreditsResponse) =>
  d.totalMilliCent;

export const isProGrowSelector = (d: UserSubscription) =>
  planNameSelector(d).includes('progrow');

export const creditsBalanceSelector = (d: PodcastPromoCreditsResponse) => ({
  remaining: millicentsToDollars(remainingMilliCentSelector(d)),
  total: millicentsToDollars(totalMilliCentSelector(d)),
});
